import { login as loginApi } from "@/api/auth";
import store from "@/store";
import { AUTH_STORAGE } from "@/store/session";
import { checkAuthData } from "@/model/auth/schema";

export function login(token, billingCode, prod) {
  // console.log(token, billingCode, prod);
  return loginApi(token, billingCode, prod)
    .then(function(result) {
      // 获取到用户信息
      // vuex更新用户信息
      // 跳转到会议列表页面
      // console.log(result);
      try {
        const token = result.data.tokenKey;
        const privilege = result.data.privilege;

        const authInfo = { prod, token, privilege };
        store.commit("setAuth", authInfo);
        sessionStorage.setItem(AUTH_STORAGE, JSON.stringify(authInfo));

        // 存储prod
        // 跳转到会议首页
      } catch (error) {
        console.log(error);
        return Promise.reject(new Error("用户数据错误"));
        // 提示用户信息数据错误
      }
      return result;
    })
    .catch(error => {
      console.log(error);
      return Promise.reject(new Error("用户登陆失败"));
    });
}

export function logout() {
  store.commit("clearUser");
  store.commit("clearAuth");
  sessionStorage.removeItem(AUTH_STORAGE);
}

/**
 * 存储auth信息到vuex和sessionStorage
 * @param {loginType: (...)
 *          refreshToken: (...)
 *          refreshTokenExpires: (...)
 *          token: (...)
 *          tokenExpires: (...)
 *          umsUserId: (...)} auth
 */
export function saveAuth(auth) {
  // 存储
  store.commit("setAuth", auth);
  sessionStorage.setItem(AUTH_STORAGE, JSON.stringify(auth));
}

export function isAuth() {
  let authToken = store.getters.authTokenInfo;
  let isAuth = false;
  if (authToken === null) {
    const sessionAuth = sessionStorage.getItem(AUTH_STORAGE);
    if (sessionAuth) {
      try {
        const auth = JSON.parse(sessionAuth);
        if (checkAuthData(auth)) {
          // 验证sessionStorage存储的token数据格式，防止用户修改后格式错误。
          store.commit("setAuth", auth);
          isAuth = true;
        }
      } catch (error) {
        console.log(error);
      }
    }
  } else {
    isAuth = true;
  }
  return isAuth;
  // 从vuex哪登录数据，
  // 如果vuex没有登录数据，就去sessionStorage获取数据，如果没有就返回没有登录
  // 如果有token信息 验证token是否过期，如果过期刷新token
}
